//@ts-ignore
import Carousel from 'platform-components/src/components/carousel/carousel';
import React from 'react';

//@ts-ignore
import { IconArrow } from 'common.components/icon';

import AdaptiveCarouselMobile from './_mobile/adaptive-carousel_mobile';

interface Props {
    initialItemIndex: number;
    isMobile: boolean;
    withControls: boolean;
    children: Array<React.ReactElement> | React.ReactElement | null;
}
export class AdaptiveCarousel extends React.Component<Props> {
    renderDesktop = (): React.ReactNode => {
        const { initialItemIndex, withControls, children } = this.props;

        return (
            <Carousel
                allowLinearScroll={true}
                initialItemIndex={initialItemIndex}
                scrollStep={500}
                transitionTimeMs={300}
            >
                {withControls && (
                    <Carousel.Controls>
                        <Carousel.Prev mix="stack__carousel-prev">
                            <div className="stack__carousel-btn">
                                <IconArrow direction={IconArrow.DIRECTIONS.LEFT} />
                            </div>
                        </Carousel.Prev>
                        <Carousel.Next mix="stack__carousel-next">
                            <div className="stack__carousel-btn">
                                <IconArrow direction={IconArrow.DIRECTIONS.RIGHT} />
                            </div>
                        </Carousel.Next>
                    </Carousel.Controls>
                )}
                <Carousel.Content>{children}</Carousel.Content>
            </Carousel>
        );
    };

    renderMobile = (): React.ReactNode => {
        const { initialItemIndex, children } = this.props;

        return <AdaptiveCarouselMobile initialItemIndex={initialItemIndex}>{children}</AdaptiveCarouselMobile>;
    };

    render() {
        const { isMobile } = this.props;

        if (isMobile) {
            return this.renderMobile();
        }

        return this.renderDesktop();
    }
}

export default AdaptiveCarousel;
